import React, { createContext, useContext, useMemo } from 'react';
import { studioTypeSize } from '../../utils/typeScale';

const StudioTypeSizeContext = createContext<(px: number) => number>(px => px);

interface StudioTypeScaleProviderProps {
  locale?: string;
  children: React.ReactNode;
}

export const StudioTypeScaleProvider: React.FC<StudioTypeScaleProviderProps> = ({ locale, children }) => {
  const scaleSize = useMemo(() => (px: number) => studioTypeSize(px, locale), [locale]);
  return <StudioTypeSizeContext.Provider value={scaleSize}>{children}</StudioTypeSizeContext.Provider>;
};

export const useStudioTypeSize = (): ((px: number) => number) => useContext(StudioTypeSizeContext);
